// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1-O5M","emails":"CreateEditClinics_emails__2FZcA","emailTagLabel":"CreateEditClinics_emailTagLabel__3Lk2b"};